<app-backgrop>
  @if (showGameContainer) {
    <div class="w-full grid grid-cols-4 landscape:grid-cols-8 landscape:pt-10 landscape:max-w-9/10 landscape:max-h-full landscape:overflow-y-auto landscape:overflow-x-hidden custom-scrll p-2 md:p-0 md:grid-cols-5 md:landscape:grid-cols-5 gap-2 md:landscape:gap-5 md:landscape:w-[980px] md:w-[980px] md:gap-5 pt-20 md:pt-unset cards-container">
      @for (item of cards; track $index) {
        <div class="card-wrapper" (click)="playOpenCard(); openCard(item)">
          <div class="card"  [class.disabled]="disabled" [class.opened]="item.open || item.finded">
            <div class="card-box card-back bg-back">
            <picture>
              <source srcset="./assets-compressed/categories/witch/find-a-pair/back.webp" type="image/webp">
              <img src="./assets-compressed/categories/witch/find-a-pair/back.png" alt="" class="img">
            </picture>
            </div>
            <div [class]="'card-box card-img-border noise card-front'">
              <div [class]="'card-img bg-' + item.card"></div>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (showResult) {
    <app-result-modal-with-actions
      (successClicked)="close(true)"
      (rejectClicked)="reset()"
    ></app-result-modal-with-actions>
  }
</app-backgrop>

@if (showCenterText) {
  <app-center-text class="relative z-1000" [params]="showCenterTextParam" [completedFn]="completedFn"/>
}